import { LibraryTab } from '@/types/library';
import { retrieveFeaturesSession } from '@/utils/browserStorage';

export const useLibraryTabs = () => {
  const isFileToAudioAllowed = retrieveFeaturesSession()?.fileToAudio;

  const libraryTabs: LibraryTab[] = [
    ...(isFileToAudioAllowed
      ? [
          {
            id: 'audio',
            label: 'library.tab.audio',
            link: 'audio',
          } as LibraryTab,
        ]
      : []),
    {
      id: 'following',
      label: 'library.tab.followed',
      link: 'following',
    },
    {
      id: 'history',
      label: 'library.tab.history',
      link: 'history',
    },
  ];

  return { libraryTabs };
};
